const countryCodes = [
  { code: '+1', country: 'US', flag: '\u{1F1FA}\u{1F1F8}', name: 'United States' },
  { code: '+1', country: 'CA', flag: '\u{1F1E8}\u{1F1E6}', name: 'Canada' },
  { code: '+44', country: 'GB', flag: '\u{1F1EC}\u{1F1E7}', name: 'United Kingdom' },
  { code: '+91', country: 'IN', flag: '\u{1F1EE}\u{1F1F3}', name: 'India' },
  { code: '+92', country: 'PK', flag: '\u{1F1F5}\u{1F1F0}', name: 'Pakistan' },
  { code: '+61', country: 'AU', flag: '\u{1F1E6}\u{1F1FA}', name: 'Australia' },
  { code: '+64', country: 'NZ', flag: '\u{1F1F3}\u{1F1FF}', name: 'New Zealand' },
  { code: '+49', country: 'DE', flag: '\u{1F1E9}\u{1F1EA}', name: 'Germany' },
  { code: '+33', country: 'FR', flag: '\u{1F1EB}\u{1F1F7}', name: 'France' },
  { code: '+34', country: 'ES', flag: '\u{1F1EA}\u{1F1F8}', name: 'Spain' },
  { code: '+39', country: 'IT', flag: '\u{1F1EE}\u{1F1F9}', name: 'Italy' },
  { code: '+31', country: 'NL', flag: '\u{1F1F3}\u{1F1F1}', name: 'Netherlands' },
  { code: '+32', country: 'BE', flag: '\u{1F1E7}\u{1F1EA}', name: 'Belgium' },
  { code: '+41', country: 'CH', flag: '\u{1F1E8}\u{1F1ED}', name: 'Switzerland' },
  { code: '+43', country: 'AT', flag: '\u{1F1E6}\u{1F1F9}', name: 'Austria' },
  { code: '+46', country: 'SE', flag: '\u{1F1F8}\u{1F1EA}', name: 'Sweden' },
  { code: '+47', country: 'NO', flag: '\u{1F1F3}\u{1F1F4}', name: 'Norway' },
  { code: '+45', country: 'DK', flag: '\u{1F1E9}\u{1F1F0}', name: 'Denmark' },
  { code: '+358', country: 'FI', flag: '\u{1F1EB}\u{1F1EE}', name: 'Finland' },
  { code: '+48', country: 'PL', flag: '\u{1F1F5}\u{1F1F1}', name: 'Poland' },
  { code: '+351', country: 'PT', flag: '\u{1F1F5}\u{1F1F9}', name: 'Portugal' },
  { code: '+30', country: 'GR', flag: '\u{1F1EC}\u{1F1F7}', name: 'Greece' },
  { code: '+353', country: 'IE', flag: '\u{1F1EE}\u{1F1EA}', name: 'Ireland' },
  { code: '+420', country: 'CZ', flag: '\u{1F1E8}\u{1F1FF}', name: 'Czech Republic' },
  { code: '+36', country: 'HU', flag: '\u{1F1ED}\u{1F1FA}', name: 'Hungary' },
  { code: '+40', country: 'RO', flag: '\u{1F1F7}\u{1F1F4}', name: 'Romania' },
  { code: '+380', country: 'UA', flag: '\u{1F1FA}\u{1F1E6}', name: 'Ukraine' },
  { code: '+7', country: 'RU', flag: '\u{1F1F7}\u{1F1FA}', name: 'Russia' },
  { code: '+90', country: 'TR', flag: '\u{1F1F9}\u{1F1F7}', name: 'Turkey' },
  { code: '+972', country: 'IL', flag: '\u{1F1EE}\u{1F1F1}', name: 'Israel' },
  { code: '+971', country: 'AE', flag: '\u{1F1E6}\u{1F1EA}', name: 'UAE' },
  { code: '+966', country: 'SA', flag: '\u{1F1F8}\u{1F1E6}', name: 'Saudi Arabia' },
  { code: '+974', country: 'QA', flag: '\u{1F1F6}\u{1F1E6}', name: 'Qatar' },
  { code: '+973', country: 'BH', flag: '\u{1F1E7}\u{1F1ED}', name: 'Bahrain' },
  { code: '+968', country: 'OM', flag: '\u{1F1F4}\u{1F1F2}', name: 'Oman' },
  { code: '+965', country: 'KW', flag: '\u{1F1F0}\u{1F1FC}', name: 'Kuwait' },
  { code: '+962', country: 'JO', flag: '\u{1F1EF}\u{1F1F4}', name: 'Jordan' },
  { code: '+961', country: 'LB', flag: '\u{1F1F1}\u{1F1E7}', name: 'Lebanon' },
  { code: '+86', country: 'CN', flag: '\u{1F1E8}\u{1F1F3}', name: 'China' },
  { code: '+81', country: 'JP', flag: '\u{1F1EF}\u{1F1F5}', name: 'Japan' },
  { code: '+82', country: 'KR', flag: '\u{1F1F0}\u{1F1F7}', name: 'South Korea' },
  { code: '+65', country: 'SG', flag: '\u{1F1F8}\u{1F1EC}', name: 'Singapore' },
  { code: '+852', country: 'HK', flag: '\u{1F1ED}\u{1F1F0}', name: 'Hong Kong' },
  { code: '+886', country: 'TW', flag: '\u{1F1F9}\u{1F1FC}', name: 'Taiwan' },
  { code: '+60', country: 'MY', flag: '\u{1F1F2}\u{1F1FE}', name: 'Malaysia' },
  { code: '+62', country: 'ID', flag: '\u{1F1EE}\u{1F1E9}', name: 'Indonesia' },
  { code: '+63', country: 'PH', flag: '\u{1F1F5}\u{1F1ED}', name: 'Philippines' },
  { code: '+66', country: 'TH', flag: '\u{1F1F9}\u{1F1ED}', name: 'Thailand' },
  { code: '+84', country: 'VN', flag: '\u{1F1FB}\u{1F1F3}', name: 'Vietnam' },
  { code: '+880', country: 'BD', flag: '\u{1F1E7}\u{1F1E9}', name: 'Bangladesh' },
  { code: '+94', country: 'LK', flag: '\u{1F1F1}\u{1F1F0}', name: 'Sri Lanka' },
  { code: '+977', country: 'NP', flag: '\u{1F1F3}\u{1F1F5}', name: 'Nepal' },
  { code: '+55', country: 'BR', flag: '\u{1F1E7}\u{1F1F7}', name: 'Brazil' },
  { code: '+52', country: 'MX', flag: '\u{1F1F2}\u{1F1FD}', name: 'Mexico' },
  { code: '+54', country: 'AR', flag: '\u{1F1E6}\u{1F1F7}', name: 'Argentina' },
  { code: '+56', country: 'CL', flag: '\u{1F1E8}\u{1F1F1}', name: 'Chile' },
  { code: '+57', country: 'CO', flag: '\u{1F1E8}\u{1F1F4}', name: 'Colombia' },
  { code: '+51', country: 'PE', flag: '\u{1F1F5}\u{1F1EA}', name: 'Peru' },
  { code: '+58', country: 'VE', flag: '\u{1F1FB}\u{1F1EA}', name: 'Venezuela' },
  { code: '+27', country: 'ZA', flag: '\u{1F1FF}\u{1F1E6}', name: 'South Africa' },
  { code: '+234', country: 'NG', flag: '\u{1F1F3}\u{1F1EC}', name: 'Nigeria' },
  { code: '+254', country: 'KE', flag: '\u{1F1F0}\u{1F1EA}', name: 'Kenya' },
  { code: '+20', country: 'EG', flag: '\u{1F1EA}\u{1F1EC}', name: 'Egypt' },
  { code: '+212', country: 'MA', flag: '\u{1F1F2}\u{1F1E6}', name: 'Morocco' },
  { code: '+233', country: 'GH', flag: '\u{1F1EC}\u{1F1ED}', name: 'Ghana' },
  { code: '+255', country: 'TZ', flag: '\u{1F1F9}\u{1F1FF}', name: 'Tanzania' },
  { code: '+256', country: 'UG', flag: '\u{1F1FA}\u{1F1EC}', name: 'Uganda' },
  { code: '+251', country: 'ET', flag: '\u{1F1EA}\u{1F1F9}', name: 'Ethiopia' },
];

export default countryCodes;
